module.exports = __webpack_public_path__ + "static/pixie-live-c9eab8d988408c76296170c1660b81d6.webm";